import Contact from '@/components/Contact';
import Layout from '@/components/Layout';
Contact.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='contact' >{page}</Layout>
    );
};

export default Contact;


